import React, { useState } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components/macro";
// import { Link } from 'react-router-dom';
// import Icon from 'components/Icon';

export const styles = css`
  --button-bg: ${(props) =>
    props.color ? `var(--c-${props.color})` : "transparent"};
  --button-text: ${(props) =>
    props.color ? `var(--c-${props.color}--text)` : "var(--c-body)"};
  --button-bg-hover: ${(props) =>
    props.color ? `var(--c-${props.color}--hover)` : "rgba(255,255,255,0)"};
  --button-bg-hover-text: ${(props) =>
    props.color
      ? `var(--c-${props.color}--hover--text)`
      : "var(--button-text)"};
  --button-b-width: ${(props) => (props.color ? "0" : "var(--b-width)")};
  --button-font: ${(props) =>
    props.small
      ? "var(--f-weight-normal) 1.125rem 'Yanone Kaffeesatz', Impact, sans-serif"
      : "var(--f-body-big)"};
  --button-padding: ${(props) =>
    props.small ? "var(--s-tiny) var(--s-small)" : "18px var(--s-medium)"};

  font: 18px;
  font-weight: var(--f-weight-bold);
  letter-spacing: var(--f-special-spacing);
  ${(props) =>
    props.wide
      ? `
      display: flex;
      width: 100%;
    `
      : `display: inline-flex`}
  justify-content: center;
  align-items: center;
  position: relative;
  border: none;
  background-color: var(--button-bg);
  padding: var(--button-padding);
  cursor: pointer;
  text-decoration: none;
  color: var(--button-text);
  text-align: center;
  overflow: hidden;
  /*
  @media (min-width: 500px) {
    min-width: 200px;
  } */
  /* for focus state, transform for stacked wide buttons */
  transition: box-shadow var(--t-fast) var(--e-out),
    opacity var(--t-slow) linear, background-color var(--t-base),
    transform var(--t-base) var(--e-out), color var(--t-fast) var(--e-out);
  /* for focus state */
  box-shadow: inset 0 0 0 var(--button-b-width) var(--c-primary),
    0 0 0 0 rgba(255, 255, 255, 0);

  /* Normalize */
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  ::-moz-focus-inner {
    border: 0;
  }

  &:focus {
    outline: none;
    /* box-shadow: inset 0 0 0 var(--button-b-width) var(--c-primary),
      0 0 0 4px var(--c-primary--opacity); */
  }
  &:hover {
    text-decoration: none;
    background-color: var(--button-bg-hover);
    color: var(--button-bg-hover-text);
    /* box-shadow:
    inset 0 0 0 var(--button-b-width) var(--button-bg-hover),
    0 0 0 0 rgba(255,255,255,0); */
  }
  &:disabled {
    color: var(--c-disabled);
    background-color: var(--c-white);
    cursor: auto;
    pointer-events: none;
    box-shadow: inset 0 0 0 var(--button-b-width) var(--c-disabled),
      0 0 0 0 rgba(255, 255, 255, 0);
  }

  @keyframes ripple {
    0% {
      transform: scale(0, 0);
      opacity: 1;
    }
    100% {
      opacity: 0;
      transform: scale(20, 20);
    }
  }

  &:focus::after {
    animation: ripple 1.5s var(--e-out);
  }
`;

const ButtonButton = styled.button`
  ${styles}
`;
const ButtonLink = styled.a`
  ${styles}
`;

const IconStyle = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

function Button(props) {
  const [loadingState, setLoadingState] = useState(false);

  // useEffect(() => {
  //   setLoading(props.loading)
  // }, [props.loading]);

  const {
    children,
    loading,
    loadingOnClick,
    loadingIcon,
    onClick,
    href,
    ...restProps
  } = props;

  if (href) {
    return (
      <ButtonLink {...restProps} href={href}>
        {children}
      </ButtonLink>
    );
  }

  return (
    <ButtonButton
      {...restProps}
      onClick={
        onClick
          ? () => {
              if (loadingOnClick) {
                setLoadingState(true);
              }
              onClick();
            }
          : undefined
      }
    >
      {children}
      {(loading || loadingState) && <IconStyle>{loadingIcon}</IconStyle>}
    </ButtonButton>
  );
}

Button.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  disabled: PropTypes.bool,
  onClick: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  href: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  loadingOnClick: PropTypes.bool,
  loading: PropTypes.bool,
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  loadingIcon: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  small: PropTypes.bool,
  wide: PropTypes.bool,
};

Button.defaultProps = {
  loadingIcon: "[i]",
  disabled: undefined,
  onClick: undefined,
  href: undefined,
  loadingOnClick: undefined,
  loading: undefined,
  color: undefined,
  small: undefined,
  wide: undefined,
};
Button.displayName = "Button";
export default Button;
